import { T } from "../themes";

export default function MeasurementSparkline({ data, color, width=140, height=36 }) {
  if (!data || data.length < 2) return null;
  const fullWidth = width === "100%";
  const W = fullWidth ? 300 : width;
  const H = height, PAD = 6;
  const vals = data.map(d=>d.v);
  const mn=Math.min(...vals)-0.5, mx=Math.max(...vals)+0.5;
  const xS = i => PAD+(i/(vals.length-1||1))*(W-PAD*2);
  const yS = v => H-PAD-((v-mn)/(mx-mn||1))*(H-PAD*2);
  const pathD = vals.map((v,i)=>`${i===0?"M":"L"}${xS(i).toFixed(1)},${yS(v).toFixed(1)}`).join(" ");
  return (
    <svg width={fullWidth?"100%":W} height={H} viewBox={fullWidth?`0 0 ${W} ${H}`:undefined} preserveAspectRatio="none" style={{display:"block"}}>
      <path d={pathD} fill="none" stroke={color||T.accent} strokeWidth={2} strokeLinejoin="round"/>
      <circle cx={xS(vals.length-1)} cy={yS(vals[vals.length-1])} r={3} fill={color||T.accent} stroke={T.ink} strokeWidth={1.5}/>
    </svg>
  );
}
